import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;
// Pusher.logToConsole = true;

const echo = new Echo({
  broadcaster: "pusher",
  key: process.env.REACT_APP_PUSHER_APP_KEY,
  cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
  forceTLS: true,
  enabledTransports: ["ws", "wss"],
});

export default echo;
